module.exports = __webpack_public_path__ + "img/Group 14.e618083a.png";